import { useDataEntryGroup } from "./data-entry-group.hook";
import { Button, Loader } from "src/ui/widgets";
import { EntryGroupStep2 } from "./entry-group-step2/entry-group-step-2";
import { RightArrowIcon } from "src/assets";
import { Formik, FormikInsurance } from "src/types";
import { DataEntryStep2 } from "../manage-data-normal/data-entry-step-2/data-entry-step-2";
import { DataEntryStep3 } from "../manage-data-normal/data-entry-step-3/data-entry-step-3";
import { DataEntryStep4 } from "../manage-data-normal/data-entry-step-4/data-entry-step-4";
import { DataEntryStep5 } from "../manage-data-normal/data-entry-step-5/data-entry-step-5";

export const DataEntryGroup = ({
  currentStep,
  insuranceFormik,
}: {
  currentStep: number;
  insuranceFormik: Formik<FormikInsurance>;
}) => {
  const {
    isDisabled,
    insuredValidationSchema,
    evaluatedPremium,
    postEvaluatePremiumPending,
    t,
    evaluatePremium,
    triggerFormikCheck,
  } = useDataEntryGroup({
    insuranceFormik,
  });

  const { handleSubmit } = insuranceFormik;

  const SubmitButton = (
    <div className="col-12 mb-2 pt-4 pt-md-0 mb-md-1">
      <div className="d-md-flex justify-content-center justify-content-md-between">
        {currentStep < 3 && (
          <>
            {
              <div>
                <div className="pe-md-4 mb-4 mb-md-0 d-flex d-md-block justify-content-center">
                  <Button
                    classes="primary d-flex justify-content-center button-submit m-md-0"
                    classesText="font-medium-s text-uppercase"
                    onPress={evaluatePremium}
                    text={t("data_entry_step_1.evaluate")}
                    disabled={isDisabled}
                  />
                </div>
              </div>
            }
            <div />
            <div>
              <Button
                type="submit"
                text={t("commons.continue")}
                classes="primary d-flex justify-content-center button-submit m-md-0"
                classesText="font-medium-s text-uppercase"
                iconSize={20}
                iconRight={RightArrowIcon}
                classesIconRight="ms-2 filter-ffffff"
                disabled={currentStep === 1 && isDisabled}
                onPress={triggerFormikCheck}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );

  const Form = (
    <>
      {currentStep === 1 && (
        <EntryGroupStep2
          insuranceFormik={insuranceFormik}
          validationSchema={insuredValidationSchema}
        />
      )}
      {currentStep === 2 && (
        <DataEntryStep2
          formik={insuranceFormik}
          validationSchema={insuredValidationSchema}
        />
      )}
      {currentStep === 3 && (
        <DataEntryStep3
          formik={insuranceFormik}
          validationSchema={insuredValidationSchema}
        />
      )}
      {currentStep === 4 && (
        <DataEntryStep4
          formik={insuranceFormik}
          validationSchema={insuredValidationSchema}
        />
      )}
      {currentStep === 5 && <DataEntryStep5 />}
    </>
  );

  const Total = currentStep <= 2 && (
    <div className="col-md-12 pl-md-3 mb-2 pt-4 pt-md-0 mb-md-1">
      <div className="col-md-6 d-block d-md-flex align-items-center mb-3 pe-md-3">
        <div className="col-md-5 col-md-5 mb-3 mb-md-0">
          <div className="d-md-block">
            {postEvaluatePremiumPending ? (
              <div className="m-auto d-flex justify-content-center mb-3">
                <Loader overlay />
              </div>
            ) : (
              evaluatedPremium?.premium?.quoteValue && (
                <div className="d-flex justify-content-center justify-content-md-start align-items-center">
                  <div>
                    <div className="font-18-semibold c-7f7f7f text-center ">
                      {t("data_entry.total")}
                    </div>
                    <div className="font-38-semibold text-center c-secondary">
                      <div>
                        {evaluatedPremium?.premium?.quoteValue !== undefined
                          ? evaluatedPremium?.premium?.quoteValue
                              .toFixed(2)
                              .replace(".", ",")
                          : "-"}{" "}
                        €
                      </div>
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <form onSubmit={handleSubmit}>
      {Form}
      {Total}
      <div className="mt-5 mb-3 border-top" />
      {SubmitButton}
    </form>
  );
};
